// Visits are private to the account; note acknowledgements remain explicit.
export const resourceViewKey = (kind, teamId, mapId, resourceId) =>
  encodeURIComponent(JSON.stringify([kind, teamId, mapId || '', resourceId]));

const list = value => Array.isArray(value) ? value : [];
const identity = value => String(value || '').replace(/^@/, '').trim().toLowerCase();
export const activeReviewItem = item => !item?.deleted && !item?.isDeleted && !item?.deletedAt && !item?.reviewMovedTo;
export function resourceNoteReviewState(item,uid,username,role='') {
  const identities=new Set([uid,username].filter(Boolean).map(identity));
  const roleKey=value=>({players:'player',coaches:'coach',analysts:'analyst',managers:'manager',subs:'sub',substitute:'sub'})[identity(value)]||identity(value);
  const viewed=[...list(item.viewers),...list(item.viewedByUids)].some(value=>identities.has(identity(value)));
  const relevant=[...list(item.at),...list(item.mentions)].some(value=>identity(value)==='team'||identities.has(identity(value))||(role&&roleKey(value)===roleKey(role)));
  return {viewed,relevant};
}

export function hasPendingResourceNotes(notes, replies, uid, username) {
  return pendingResourceNoteIds(notes,replies,uid,username).length>0;
}

// Count note threads once, even when several unread replies belong to a note.
export function pendingResourceNoteIds(notes, replies, uid, username) {
  const identities = new Set([uid, username].filter(Boolean).map(identity));
  const mine = value => identities.has(identity(value));
  const authored = item => mine(item.createdByUid || item.authorUid || item.createdBy);
  const viewed = item => [...list(item.viewers), ...list(item.viewedByUids)].some(mine);
  const relevant = item => [...list(item.at), ...list(item.mentions)].some(tag => identity(tag) === 'team' || mine(tag));
  const pending=new Set(notes.filter(item=>activeReviewItem(item)&&relevant(item)&&!viewed(item)).map((item,index)=>item.id||`note-${index}`));
  const parents = new Map(notes.map(item => [item.id, item]));
  replies.forEach(item => {
    const parent = parents.get(item.noteId);
    if(parent && activeReviewItem(parent) && activeReviewItem(item) && !authored(item) &&
      !viewed(item) && (relevant(item) || relevant(parent) || authored(parent)))pending.add(parent.id);
  });
  return [...pending];
}

export function resourceReviewState(items, checking = false, error = false) {
  const present = items.length > 0;
  const reviewed = present && !checking && !error && items.every(item => item.viewed && !item.pending && !item.processing);
  return {present, reviewed, checking, error, status: present ? reviewed ? 'is-reviewed' : 'needs-review' : 'is-missing'};
}
